import Vue from 'vue';
import createApp from '@/app';
Vue.use(require('vueperslides/dist/vueperslides.css'));
Vue.use(require('vue-slider-component/theme/default.css'));
Vue.config.productionTip = process.env.NODE_ENV === 'production';
export const { app, router, store, apolloClient, legacyClient } = createApp();
app.$mount('#app');
